import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Zendesk extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <polygon points="11.0541872 5.52118227 11.0541872 18.8689655 -8.8817842e-15 18.8689655" />
        <path d="M11.0541872,-3.55271368e-15 C11.0541872,3.05024631 8.58325123,5.52118227 5.53300493,5.52118227 C2.48275862,5.52118227 -8.8817842e-15,3.05024631 -8.8817842e-15,-3.55271368e-15 L11.0541872,-3.55271368e-15 Z" />
        <path d="M24.1083744,18.8807882 L24.1083744,18.8807882 L13.0541872,18.8807882 C13.0541872,15.8305419 15.5251232,13.3477833 18.5753695,13.3477833 C21.6256158,13.3596059 24.0965517,15.8305419 24.1083744,18.8807882 Z" />
        <polygon points="13.0541872 13.3477833 13.0541872 2.66453526e-15 24.1083744 2.66453526e-15" />
      </svg>
    );
  }
}

export default Zendesk;
